import React from "react";
import Tooltip from "@mui/material/Tooltip";
const StyleTooltip = ({ title='', placement="top-start",fontColor="gray", open, children }) => {
  return (
    <Tooltip
      title={title}
      open={open}
      arrow
      placement={placement}
      slotProps={{
        tooltip: {
          sx: {
            color:fontColor,
            backgroundColor: "white",
            boxShadow: 3,
          },
        },
        arrow: {
          sx: {
            color: "white",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};


export default StyleTooltip;